import { Attribute } from './Attribute.js';

export const END_DATE_LIST_ATTRIBUTE_TYPE = 'EndDateListAttribute';
export const END_DATE_LIST_ATTRIBUTE_ID = 'EndDateList';

/**
 * @property {string[]} values
 */
export class EndDateListAttribute extends Attribute {
  constructor({ values }) {
    super();
    this.values = values;
    this.isReadOnly = true;
    this.type = END_DATE_LIST_ATTRIBUTE_TYPE;
  }
}
